(() => {
  const footerSelector = '.shopify-section-group-footer-group.section-apps';
  const formSelector = footerSelector + ' [data-forms-id="forms-root-1016740"] shopify-forms-embed';
  const shadowStyleId = 'elkline-footer-forms-theme';
  const shellStyleId = 'elkline-footer-forms-shell';

  const shadowCss = `
    :host {
      --forms-base-font-size: 14px !important;
      --forms-heading-font-size: 30px !important;
      --forms-body-font: normal 400 14px montserrat, Arial, sans-serif !important;
      --forms-heading-font: normal 700 30px termina, montserrat, Arial, sans-serif !important;
      --inline-container-max-width: 920px !important;
      --container-max-w: 920px !important;
      --forms-padding-top: 24px !important;
      --forms-padding-bottom: 20px !important;
      --forms-padding-left: 0px !important;
      --forms-padding-right: 0px !important;
      --form-field-border-radius: 0px !important;
      --button-border-radius: 0px !important;
      --button-padding: 14px !important;
    }

    section[role="dialog"] {
      width: 100% !important;
      max-width: 920px !important;
    }

    section[role="dialog"] h2 {
      margin: 0 0 7px !important;
      font-family: termina, montserrat, Arial, sans-serif !important;
      font-size: clamp(25px, 3vw, 32px) !important;
      font-weight: 700 !important;
      letter-spacing: -0.035em !important;
      line-height: 1.05 !important;
    }

    section[role="dialog"] h2 + div {
      margin-bottom: 16px !important;
      font-family: termina, montserrat, Arial, sans-serif !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      letter-spacing: 0.09em !important;
      line-height: 1.35 !important;
      text-transform: uppercase !important;
    }

    [data-testid="form"] {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) 220px !important;
      grid-template-rows: 0 auto auto !important;
      column-gap: 10px !important;
      row-gap: 11px !important;
      width: 100% !important;
      max-width: 760px !important;
      margin: 0 auto !important;
    }

    [data-testid="form"] > :first-child {
      grid-column: 1 / -1 !important;
      grid-row: 1 !important;
      min-height: 0 !important;
    }

    [data-testid="form"] > :nth-child(2) {
      grid-column: 1 !important;
      grid-row: 2 !important;
      margin: 0 !important;
    }

    [data-testid="form"] > fieldset {
      grid-column: 1 / -1 !important;
      grid-row: 3 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    [data-testid="btn-form-submit"] {
      grid-column: 2 !important;
      grid-row: 2 !important;
      width: 220px !important;
      height: 48px !important;
      min-height: 48px !important;
      padding: 0 18px !important;
      box-sizing: border-box !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      border-radius: 0 !important;
      font-family: termina, montserrat, Arial, sans-serif !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      letter-spacing: 0.075em !important;
      text-transform: uppercase !important;
      line-height: 1 !important;
      transition: filter 160ms ease, transform 160ms ease !important;
    }

    [data-testid="btn-form-submit"]:hover {
      filter: brightness(1.04) !important;
      transform: translateY(-1px) !important;
    }

    [data-testid="field-email"] {
      height: 48px !important;
      min-height: 48px !important;
      box-sizing: border-box !important;
      border-radius: 0 !important;
      font-family: montserrat, Arial, sans-serif !important;
    }

    fieldset input[type="checkbox"] {
      accent-color: #f5b51b !important;
    }

    [data-testid="form"] + div {
      max-width: 650px !important;
      margin: 12px auto 0 !important;
      opacity: 0.72 !important;
      font-size: 10px !important;
      line-height: 1.45 !important;
    }

    @media (max-width: 640px) {
      :host {
        --forms-heading-font-size: 25px !important;
        --forms-padding-top: 22px !important;
        --forms-padding-bottom: 22px !important;
      }

      [data-testid="form"] {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: 0 auto auto auto !important;
        max-width: 100% !important;
      }

      [data-testid="form"] > :nth-child(2) {
        grid-column: 1 !important;
        grid-row: 2 !important;
      }

      [data-testid="form"] > fieldset {
        grid-column: 1 !important;
        grid-row: 3 !important;
      }

      [data-testid="btn-form-submit"] {
        grid-column: 1 !important;
        grid-row: 4 !important;
        width: 100% !important;
        max-width: 100% !important;
        height: 48px !important;
        padding: 0 16px !important;
        box-sizing: border-box !important;
      }

      fieldset > div {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 8px 16px !important;
      }
    }
  `;

  const shellCss = `
    ${footerSelector} {
      overflow: hidden;
      border-top: 4px solid #f5b51b;
      border-bottom: 1px solid rgba(247, 244, 238, 0.16);
    }

    ${footerSelector} > div > .container {
      max-width: 1280px;
      padding-inline: clamp(20px, 4vw, 52px);
    }

    ${footerSelector} [data-form-root="true"] {
      --inline-container-min-height: 0px !important;
    }
  `;

  const installShellStyle = () => {
    if (document.getElementById(shellStyleId)) return;
    const style = document.createElement('style');
    style.id = shellStyleId;
    style.textContent = shellCss;
    document.head.appendChild(style);
  };

  const enhance = (host) => {
    const root = host.shadowRoot;
    if (!root || root.getElementById(shadowStyleId)) return Boolean(root);
    const style = document.createElement('style');
    style.id = shadowStyleId;
    style.textContent = shadowCss;
    root.appendChild(style);
    return true;
  };

  const scan = () => {
    installShellStyle();
    document.querySelectorAll(formSelector).forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 20000);
})();
